export const LAUNCH_MODAL_TRANSLATIONS: any = {
  en: {
    deptTitle: 'Odia Language Literature and Culture Department',
    presents: 'Presents',
    portalTitle: 'Amakalakara Portal',
    launchDateLabel: 'Official Launch Date',
    days: 'DD',
    hours: 'HH',
    minutes: 'MM',
    seconds: 'SS',
    regOpen: 'Registration is now open!',
    announcement: '🚀 <strong>Agency, Troupe Registration & Auditions</strong> portals opening soon! 🚀',
    tutorialTitle: 'Tutorial: How to Register',
    subMessage: 'Please check back on the launch day to access these features. Until then, feel free to explore our cultural heritage and gallery.',
    enterNow: 'Enter Now',
    exploreSite: 'Explore Site'
  },
  or: {
    deptTitle: 'ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଏବଂ ସଂସ୍କୃତି ବିଭାଗ',
    presents: 'ଉପସ୍ଥାପନ କରୁଛନ୍ତି',
    portalTitle: 'ଆମ କଳାକାର ପୋର୍ଟାଲ୍',
    launchDateLabel: 'ଆନୁଷ୍ଠାନିକ ଶୁଭାରମ୍ଭ ତାରିଖ',
    days: 'ଦିନ',
    hours: 'ଘଣ୍ଟା',
    minutes: 'ମିନିଟ୍',
    seconds: 'ସେକେଣ୍ଡ',
    regOpen: 'ପଞ୍ଜୀକରଣ ବର୍ତ୍ତମାନ ଖୋଲା ଅଛି!',
    announcement: '🚀 <strong>ଅନୁଷ୍ଠାନ, ଦଳ ପଞ୍ଜୀକରଣ ଏବଂ ଅଡିସନ</strong> ପୋର୍ଟାଲ୍ ଖୁବ୍ ଶୀଘ୍ର ଖୋଲୁଛି! 🚀',
    tutorialTitle: 'ଟ୍ୟୁଟୋରିଆଲ୍: କିପରି ପଞ୍ଜୀକରଣ କରିବେ',
    subMessage: 'ଏହି ସୁବିଧାଗୁଡ଼ିକୁ ପାଇବା ପାଇଁ ଦୟାକରି ଶୁଭାରମ୍ଭ ଦିନ ପୁଣି ଦେଖନ୍ତୁ। ସେ ପର୍ଯ୍ୟନ୍ତ ଆମର ସାଂସ୍କୃତିକ ଐତିହ୍ୟ ଏବଂ ଗ୍ୟାଲେରୀ ଅନୁସନ୍ଧାନ କରନ୍ତୁ ।',
    enterNow: 'ବର୍ତ୍ତମାନ ପ୍ରବେଶ କରନ୍ତୁ',
    exploreSite: 'ସାଇଟ୍ ଅନୁସନ୍ଧାନ କରନ୍ତୁ'
  }
};
